import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Modal from 'react-modal';

import { SpinnerWithLabel } from 'components/Spinner';
import { TradeActivitySlate } from 'apps/profile/components/ActivitySlate';
import { configureStore } from 'store/configureStore';

import { ChooseBidPaymentMethod } from 'apps/trade/ChooseBidPaymentMethod';
import { TwoFactorAuthModal } from '../modals/TwoFactorAuthModal';

const store = configureStore();

/**
 * Recent Activity
 */
const tradeApp = document.getElementsByClassName('js-trade-app')[0] as HTMLElement;

if (tradeApp) {
  Modal.setAppElement(tradeApp);
  ReactDOM.render(
    <Provider store={store}>
      <div className='container slate-container'>
        <TradeActivitySlate />
        <TwoFactorAuthModal />
      </div>
      <ChooseBidPaymentMethod userId={tradeApp.dataset.userId as number | undefined} />
    </Provider>,
    tradeApp,
  );
}

window.tradeShowLoading = (el: HTMLElement) => {
  ReactDOM.render(
    <div className='d-flex justify-content-center mb-4'>
      <SpinnerWithLabel>Loading trade data</SpinnerWithLabel>
    </div>,
    el,
  );
};
